import React, { Component } from 'react';
import { HttpRequestService } from '../services/HttpRequestService';

class CreditCardTypeSelect extends Component {

    constructor(props) {
        super(props);
        this.state = { items: [] };
        this.getTypes = this.getTypes.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.http = new HttpRequestService();
    }

    componentDidMount() {
        this.getTypes();
    }

    componentWillUnmount() {

    }

    getTypes() {
        this.http.get('/api/Customers/GetCreditCardTypes', null).then(data=>{
            this.setState({ items: data });
            if(data.length > 0 && this.props.value === 0){
                this.props.onChange(data[0].creditCardTypeID);
            }
        });
    }

    handleChange(e) {
        this.props.onChange(e.target.value);
    }

    render() {
        var options = this.state.items.map((item) =>
            <option key={item.creditCardTypeID} value={item.creditCardTypeID}>{item.creditCardName}</option>
        );

        return (
            <select className="form-control" value={this.props.value} onChange={this.handleChange}>
                {this.props.hasAllOption === true &&
                    <option value="-1">-- ALL --</option>
                }
                {options}
            </select>
        );
    }
}
export default CreditCardTypeSelect